/**
 * @generated SignedSource<<4ed013e2cf5857933899a677b85f6c49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespCreatorsComponents_itemSearch$data = {
  readonly bottomModule: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedBottomModule_bottomModule">;
  } | null> | null;
  readonly designPageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorDesigns_designPageInfo" | "SbRespDesignTiles_designPageInfo">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespDesignTiles_itemSearch" | "SbRespFollowSearchBanner_itemSearch" | "SbSharedCategoryTabs_itemSearch" | "SbSharedCreatorTopContent_itemSearch" | "SbSharedPageBreadcrumbs_itemSearch" | "SbSharedRelatedCreators_itemSearch" | "SbSharedRelatedSearches_itemSearch" | "SbSharedRelatedSellers_itemSearch" | "SbSharedTitle_itemSearch" | "SbSharedTopTileController_itemSearch" | "SharedCreatorsRootHeadingsWrapper_itemSearch" | "SharedFAQ_itemSearch" | "SharedFollowSearchProvider_itemSearch" | "SharedFollowTopButton_itemSearch" | "SharedRelatedPages_itemSearch" | "SharedRespLinksBlock_itemSearch" | "SharedWordpressArticles_itemSearch">;
  readonly " $fragmentType": "SbRespCreatorsComponents_itemSearch";
};
export type SbRespCreatorsComponents_itemSearch$key = {
  readonly " $data"?: SbRespCreatorsComponents_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsComponents_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespCreatorsComponents_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedPageBreadcrumbs_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedTopTileController_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedSearches_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespDesignTiles_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowSearchProvider_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedWordpressArticles_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowTopButton_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRelatedPages_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedCreatorsRootHeadingsWrapper_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedCreatorTopContent_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedCreators_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedCategoryTabs_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedSellers_itemSearch"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BottomModule",
      "kind": "LinkedField",
      "name": "bottomModule",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedBottomModule_bottomModule"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "maxCreatorDesigns",
          "value": 16
        }
      ],
      "concreteType": "DesignPageInfo",
      "kind": "LinkedField",
      "name": "designPageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespCreatorDesigns_designPageInfo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespDesignTiles_designPageInfo"
        }
      ],
      "storageKey": "designPageInfo(maxCreatorDesigns:16)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFAQ_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "60bff5da11016249c8550e25c3a5fbbf";

export default node;
